// Simple cart utilities using localStorage - No React component
// The cart icon will be handled directly in Navbar

export function getCartItems() {
  try {
    var stored = localStorage.getItem('slab_cart');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (e) {
    console.error('Cart parse error:', e);
  }
  return [];
}

export function saveCartItems(items) {
  try {
    localStorage.setItem('slab_cart', JSON.stringify(items));
  } catch (e) {
    console.error('Cart save error:', e);
  }
}

export function addItemToCart(card) {
  var items = getCartItems();
  // Check if already in cart
  var found = false;
  for (var i = 0; i < items.length; i++) {
    if (items[i].id === card.id) {
      found = true;
      break;
    }
  }
  if (found) {
    return false;
  }
  var imageUrl = null;
  if (card.image_url) {
    imageUrl = card.image_url;
  } else if (card.images && card.images.length > 0) {
    imageUrl = card.images[0];
  }
  items.push({
    id: card.id,
    player_name: card.player_name,
    year: card.year,
    set_name: card.set_name,
    grade_company: card.grade_company,
    grade_value: card.grade_value,
    price: card.price,
    seller_id: card.seller_id,
    seller_name: card.seller_name || 'Seller',
    image_url: imageUrl
  });
  saveCartItems(items);
  return true;
}

export function removeItemFromCart(cardId) {
  var items = getCartItems();
  var newItems = [];
  for (var i = 0; i < items.length; i++) {
    if (items[i].id !== cardId) {
      newItems.push(items[i]);
    }
  }
  saveCartItems(newItems);
  return newItems;
}

export function clearCart() {
  saveCartItems([]);
}

export function isInCart(cardId) {
  var items = getCartItems();
  for (var i = 0; i < items.length; i++) {
    if (items[i].id === cardId) {
      return true;
    }
  }
  return false;
}

export function getCartCount() {
  return getCartItems().length;
}

// Group items by seller - returns array of seller groups
export function groupBySeller(items) {
  var sellersMap = {};
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var sellerId = item.seller_id;
    if (!sellersMap[sellerId]) {
      sellersMap[sellerId] = {
        seller_id: sellerId,
        seller_name: item.seller_name,
        items: [],
        subtotal: 0,
        item_count: 0
      };
    }
    sellersMap[sellerId].items.push(item);
    sellersMap[sellerId].subtotal = sellersMap[sellerId].subtotal + item.price;
    sellersMap[sellerId].item_count = sellersMap[sellerId].item_count + 1;
  }
  var result = [];
  var keys = Object.keys(sellersMap);
  for (var j = 0; j < keys.length; j++) {
    result.push(sellersMap[keys[j]]);
  }
  return result;
}

// Calculate shipping for a seller group
// Base rate $5.99 + $1 per additional item from same seller
export function calculateSellerShipping(itemCount) {
  if (itemCount <= 0) return 0;
  return 5.99 + (itemCount - 1) * 1.00;
}

// Calculate cart totals with multi-seller support
// Single processing fee (3.5%) on total, but separate shipping per seller
export function calculateCartTotals(items) {
  if (!items || items.length === 0) {
    return {
      subtotal: 0,
      processingFee: 0,
      tax: 0,
      totalShipping: 0,
      sellerShipping: [],
      grandTotal: 0,
      sellerCount: 0,
      itemCount: 0
    };
  }

  var groups = groupBySeller(items);
  var subtotal = 0;
  var totalShipping = 0;
  var sellerShipping = [];

  for (var i = 0; i < groups.length; i++) {
    var group = groups[i];
    subtotal = subtotal + group.subtotal;
    var shipping = calculateSellerShipping(group.item_count);
    totalShipping = totalShipping + shipping;
    sellerShipping.push({
      seller_id: group.seller_id,
      seller_name: group.seller_name,
      item_count: group.item_count,
      subtotal: group.subtotal,
      shipping: shipping
    });
  }

  // Single processing fee on entire cart subtotal (3.5%)
  var processingFee = subtotal * 0.035;
  // Tax on subtotal (8%)
  var tax = subtotal * 0.08;
  // Grand total
  var grandTotal = subtotal + processingFee + tax + totalShipping;

  return {
    subtotal: Math.round(subtotal * 100) / 100,
    processingFee: Math.round(processingFee * 100) / 100,
    tax: Math.round(tax * 100) / 100,
    totalShipping: Math.round(totalShipping * 100) / 100,
    sellerShipping: sellerShipping,
    grandTotal: Math.round(grandTotal * 100) / 100,
    sellerCount: groups.length,
    itemCount: items.length
  };
}

// Build checkout payload for API with seller grouping
export function buildCheckoutPayload(items, shippingAddress) {
  var groups = groupBySeller(items);
  var totals = calculateCartTotals(items);
  
  var listingIds = [];
  for (var i = 0; i < items.length; i++) {
    listingIds.push(items[i].id);
  }

  var sellerGroups = [];
  for (var j = 0; j < groups.length; j++) {
    var group = groups[j];
    var groupListingIds = [];
    for (var k = 0; k < group.items.length; k++) {
      groupListingIds.push(group.items[k].id);
    }
    sellerGroups.push({
      seller_id: group.seller_id,
      seller_name: group.seller_name,
      listing_ids: groupListingIds,
      subtotal: group.subtotal,
      shipping: calculateSellerShipping(group.item_count)
    });
  }

  return {
    listing_ids: listingIds,
    seller_groups: sellerGroups,
    shipping_address: shippingAddress,
    totals: {
      subtotal: totals.subtotal,
      processing_fee: totals.processingFee,
      tax: totals.tax,
      total_shipping: totals.totalShipping,
      grand_total: totals.grandTotal
    },
    frontend_origin: window.location.origin,
    success_url: window.location.origin + '/orders/{order_id}?payment=success',
    cancel_url: window.location.origin + '/cart?cancelled=true'
  };
}
